import axios from 'axios';
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const pollFileAvailability = async (
  method,
  bucketName,
  key,
  interval = 500,
  maxAttempts = 30,
) => {
  let attempts = 0;

  while (attempts < maxAttempts) {
    try {
      const response = await method(bucketName, key);
      if (response.success) {
        return response.presignedUrl;
      } else {
        console.log('File not available yet, retrying...');
      }
    } catch (error) {
      console.error('Error checking file availability:', error);
    }

    attempts++;
    await delay(interval);
  }

  throw new Error('File not available after maximum attempts');
};

const downloadFile = async (presignedUrl, patientId, fileName) => {
  try {
    const response = await axios.get(presignedUrl, {
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName? fileName: `${patientId}-opu-sheet.pdf`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error('Error downloading the file', error);
  }
};

const downloadReports = async (presignedUrl, fileName) => {
  try {
    const response = await axios.get(presignedUrl, {
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${fileName}.pdf`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error('Error downloading the file', error);
  }
};

const handlePreviewPDFFile =  (file) => {
  const fileType = file.fileName.split('.').pop().toLowerCase();
  const fileUrl = file.presignedUrl;
 
  try {
    let previewContent = null;

    const screenHeight = window.innerHeight;
    const calculatedHeight = screenHeight * 0.75;
    previewContent = (
      <embed
      src={fileUrl}
      width="100%"
      height={`${calculatedHeight}px`}
      type="application/pdf"
    />
    );
    return previewContent;
  } catch (error) {
    console.error('Error previewing the file', error);
  }
};
export {
  pollFileAvailability,
  downloadFile,
  downloadReports,
  handlePreviewPDFFile,
};
